Vue.component('teamSections', {
    template: templates.teamSections,
    props: {
        user: {
          type: Object,
          required: true,
        },
        team: Number,
        show: true,
        showUsers: true
    },
    data() {
        return {
          // Add any local data properties here
        }
    },
    mounted() {
        const c = this;
        c.$root.$on('quest', data => {
          console.log('quest');
        })
    },
})